<app-informate-sub-header [headerData]="subHeaderData"></app-informate-sub-header>
<div class="container-fluid">
    <div class="row h-100">
        <div class="col-lg-3">
            <app-ice-database-sidebar [databaseDetails]="databaseDetails"></app-ice-database-sidebar>
        </div>
        <div class="col-lg-9">
            <app-ice-database-content [databaseDetails]="databaseDetails"></app-ice-database-content>
        </div>
    </div>
</div>
